export default "__VITE_ASSET__a08c448e__"